export const SHOP_BASE = 'https://shop.chilternglobal.com'

const CATEGORY_HANDLES: Record<string, string> = {
  'bags-backpacks': 'bags-and-backpacks',
  clothing: 'clothing',
  'fire-retardants': 'fire-retardants',
  'public-order': 'public-order-control-and-restraint',
  'tactical-vests': 'tactical-vests',
  'training-equipment': 'training-equipment',
}

export function getShopCollectionUrl(categorySlug: string): string {
  const handle = CATEGORY_HANDLES[categorySlug] || categorySlug
  return `${SHOP_BASE}/collections/${handle}`
}

export function getShopProductUrl(productSlug: string): string {
  return `${SHOP_BASE}/products/${productSlug}`
}

export function getShopSectorUrl(sectorSlug: string): string {
  return `${SHOP_BASE}/collections/all?sector=${sectorSlug}`
}

export function getShopFrameworkUrl(): string {
  return `${SHOP_BASE}/collections/all?framework=true`
}

export function getShopUrl(): string {
  return SHOP_BASE
}
